@import 'styles/mixins';
@import 'styles/variables';

.folderRow {
  align-items: center;
  display: flex;
  padding: 10px 8px;
  cursor: pointer;

  @include for-phone-only {
    justify-content: space-between;
  }

  &:hover {
    background-color: $gray-5;
  }

  .titleColumn {
    align-items: center;
    display: flex;
    flex: 0 0 60%;
    min-width: 0;

    .folderIcon {
      margin-right: 4px;

      &.defaultIcon {
        svg {
          margin: 0 4px;
        }
      }
    }

    .chevronIcon {
      height: 16px;
      margin-right: 12px;

      &:hover {
        cursor: pointer;
      }

      svg {
        path {
          fill: $gray-40;
        }
      }
    }

    .title {
      @include md-regular;
      color: $grey-90;

      max-width: 80%;
      @include line-clamp(1);
    }
  }

  .column {
    @include ui-sm-text;

    color: $gray-40;
    flex: 0 0 20%;
    min-width: 0;
  }
}

.narrowTooltip {
  width: 110px;
}

.folderIcon {
  align-items: center;
  display: flex;
  height: 16px;
}

.selected {
  background-color: $blue-5;
}

.disabled {
  cursor: not-allowed;
}

.spinner {
  margin: 0px 1px;
}
